import { createActionGroup, props } from '@ngrx/store';

export const dataCalendarApiActions = createActionGroup({
  source: 'DataCalendar API',
  events: {
    'Load DataCalendar data': props<{ start: string, end: string, refinery: string }>(),
    'Load DataCalendar data Success': props<{ gera: string[], cj: string[], crude: string[], program: string[], planning: string[], prices: string[], budget: string[], variableCost: string[], operatingParameter: string[] }>(),
    'Load DataCalendar data Failure': props<{ error: string }>()
  },
});
